var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
		'c-block-list-self-service-custom',
		'w-5col >=768:w-6col max-w-full mx-auto',

		{
			'c-block-list-self-service-custom--wide': _vm.isWide,
			'c-block-list-self-service-custom--solid': _vm.isWide,
		} ],attrs:{"id":("self-service-" + _vm._uid)}},[(_vm.title)?_c('LongReadTarget',{attrs:{"container-id":("self-service-" + _vm._uid),"title":_vm.title,"disabled":Boolean(_vm.accordionNestingLevel)}},[_c('BaseH2',{staticClass:"text-primary-button mb-sm",domProps:{"textContent":_vm._s(_vm.title)}})],1):_vm._e(),_vm._v(" "),_c('div',{class:[
			'c-block-list-self-service-custom__cards',
			'grid gap-x-layout-gutter gap-y-md >=1024:gap-y-sm grid-cols-1 >=1024:grid-cols-2' ]},_vm._l((_vm.selfServices),function(card){return _c('ContentCard',{key:card.key,attrs:{"id":("selfservice-" + _vm._uid + "-" + (card.id)),"name":card.name,"to":card.url,"target":card.target,"light":_vm.isWide},scopedSlots:_vm._u([{key:"before",fn:function(){return [_c('span',{domProps:{"textContent":_vm._s(
						_vm.destructureCategories(card.selfServiceCategories)
					)}})]},proxy:true}],null,true)})}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }